export const Roles = {
  Admin: 'Admin',
  ContentManager: 'ContentManager',
  Employee: 'Employee',
  Supervisor: 'Supervisor',
} as const;

export type Role = typeof Roles[keyof typeof Roles];

export const isValidRole = (role: string): role is Role => {
  return Object.values(Roles).includes(role as Role);
};

